import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {Router,ActivatedRoute} from "@angular/router";
import Splide from '@splidejs/splide';
@Component({
  selector: 'content-products',
  templateUrl: './content-products.component.html',
  styleUrls: ['./content-products.component.scss']
})
export class ContentProductsComponent implements OnInit {
  @Input() datoProducts?: any;
  @Input() cardsCatego?: any;
  @Input() jsonCustomHome?: any;
  @Input() idSplide?: any;
  idiomaActual:any;
  productV3=[40,41,42,43,56,57,58];
  productV3Norm=[63];
  productCulture=[44,45,46,47,48,49,50,55,61,62,65,67,67,71,72,73,76,77,78];
  instituto:any;
    constructor(private translateSrv: TranslateService,private router: Router,) {
      this.idiomaActual = this.translateSrv.currentLang;
      this.translateSrv.onLangChange.subscribe(() => {
        this.idiomaActual = this.translateSrv.currentLang;
      });
    }

  ngOnInit(): void {
    this.instituto=localStorage.getItem("instituto");
    console.log("datoProducts",this.datoProducts);
    console.log("cardsCatego",this.cardsCatego);
    setTimeout(() => {
      new Splide( `.splide_${this.idSplide}`, {
        perPage: 5,
        rewind: true
      } ).mount();
    });
  }

  navigateTo(datos:any,tipo:any){
    console.log("info del producto:",datos);
    if (tipo=='resul') {
      console.log(datos);

      let rutaResult:any;
      if (datos.idProducto==63) {
        rutaResult="/NOM35/resultados";
        localStorage.setItem('productoID',datos.data.idCertificar);
        localStorage.setItem('FechaNorma',datos.data.fechaCertificar.toString());
        localStorage.setItem('fechaProductoRequerimientos',datos.data.fechaCertificar.toString());
        localStorage.setItem('institutoRquerimientos', localStorage.getItem('instituto'));
        localStorage.setItem('productoIDRequerimientos', datos.data.idCertificar);
        localStorage.setItem('tipoNorma35', 'v3');
        localStorage.setItem('tipoProductoRequerimientos', 'Nom3');
      }else{
        switch (datos.data.idProducto) {
          case 40: case 56: case 57: case 58:rutaResult="/results/trust_index/certificar";break;
          case 41:rutaResult="/results/trust_index/medir";break;
          case 42:rutaResult="/results/trust_index/pulse-check";break;
          default:
          break;
        }
        localStorage.setItem('productoID', datos.data.idCertificar);
        localStorage.setItem('tipoMedir',datos.idProducto);
        localStorage.setItem('fechaProductorResult',datos.data.fechaCertificar);

      }
      this.router.navigate([rutaResult]);
    }else if(tipo=='prod'){
      let ruta="";
      if (datos.idProducto!="culture") {
        if (this.productV3.includes(datos.data!.idProducto)) {
          console.log("si pertenece");
          console.log("datos.data.idProducto",datos.data.idProducto);

          switch (datos.data.idProducto) {
            case 40:ruta="certify_t3/wizard/languages";localStorage.setItem('tipoProductoRequerimientos', "c3");localStorage.setItem('tipoProducto', "3");break;
            case 41:ruta="measurement_t7/wizard/languages";localStorage.setItem('tipoProductoRequerimientos', "m7");localStorage.setItem('tipoProducto', "m7");break;
            case 42:ruta="pulse_t1/wizard/languages";localStorage.setItem('tipoProductoRequerimientos', "p1");localStorage.setItem('tipoProducto', "p1");break;
            case 43:ruta="focus_t1/wizard/languages";localStorage.setItem('tipoProductoRequerimientos', "f1");localStorage.setItem('tipoProducto', "f1");break;
            case 56:ruta="amco_1/wizard/languages";localStorage.setItem('tipoProductoRequerimientos', "am1");localStorage.setItem('tipoProducto', "am1");break;
            case 57:ruta="traba_digno/wizard/languages";localStorage.setItem('tipoProductoRequerimientos', "td1");localStorage.setItem('tipoProducto', "td1");break;
            case 58:ruta="prime_emple/wizard/languages";localStorage.setItem('tipoProductoRequerimientos', "pe1");localStorage.setItem('tipoProducto', "pe1");break;
            default:
            break;
          }
          console.log("navigateTo ruta:",ruta);
          localStorage.setItem('fechaProducto', datos.data.fechaCertificar);
          localStorage.setItem('productoID', datos.data.idCertificar);
          ////Variables para los requerimientos tecnicos/////
          localStorage.setItem('fechaProductoRequerimientos', datos.data.fechaCertificar);
          localStorage.setItem('productoIDRequerimientos', datos.data.idCertificar);
          localStorage.setItem('modifUrlShort', datos.data.surveyProductId.config.customSurveyUrl);
          localStorage.setItem('closeNotice', datos.data.surveyProductId.config.closeNotice);
          localStorage.setItem('selectNotice1', datos.data.surveyProductId.config.selectNotice1);
          localStorage.setItem('selectNotice2', datos.data.surveyProductId.config.selectNotice2)
          console.log(ruta);

          this.router.navigate([ruta]);

        }else if(this.productV3Norm.includes(datos.data.idProducto)){
          ruta="/NOM35-ENC/wizard-enc_t3/collaborators";
          localStorage.setItem('tipoProducto', "NOM35V3");
          localStorage.setItem('productoID',datos.data.idCertificar);
          localStorage.setItem('FechaNorma',datos.data.fechaCertificar.toString());
          localStorage.setItem('fechaProductoRequerimientos',datos.data.fechaCertificar.toString());
          localStorage.setItem('institutoRquerimientos', localStorage.getItem('instituto'));
          localStorage.setItem('productoIDRequerimientos', datos.data.idCertificar);
          localStorage.setItem('tipoNorma35', 'v3');
          localStorage.setItem('tipoProductoRequerimientos', 'Nom3');
          this.router.navigate([ruta]);
        }
      }else{
        ruta='cultureAudit/';
        this.router.navigate([ruta,datos.data.asociadoId]);
        console.log("es Culture audit");

      }

    }
  }

}
